@if (alertInfo.show) {
  <ngb-alert [type]="alertInfo.type" (closed)="alertInfo.show = false">
    {{ alertInfo.message }}
  </ngb-alert>
}
<form [formGroup]="form" class="needs-validation">
  <div class="row g-3">
    <div class="col-sm-6 col-md-4 mt-2">
      <autocomplete-field [label]="'Company Name'" [placeholder]="'Search...'"
        [inputFormControl]="getAutocompleteCompanyNameInput()" [readonly]="readonlyCustomerForm"
        [displayKeyValue]="false" (valueChange)="onSearchValueChange($event)" [apiService]="customerService"
        [apiMethod]="'list'" [minChars]="1" [useApiSearch]="true" [optionsKey]="'customers'"
        [valueOption]="'companyName'" [keyOption]="'customerId'" />
    </div>
    <div class="col-sm-6 col-md-4 mt-2">
      <select-field label="Customer type" [selectFormControl]="getCustomerTypetInput()"
        [readonly]="readonlyCustomerForm" [options]="optionsCustomerType" />
    </div>
    <div class="col-sm-6 col-md-4 mt-2">
      <input-field type="text" [inputFormControl]="getBrandInput()" label="Brand" placeholder="Brand"
        [readonly]="readonlyCustomerForm" />
    </div>
    <div class="col-sm-6 col-md-3 mt-2">
      <autocomplete-field [label]="'Country'" [placeholder]="'Search...'" [options]="countriesOptions"
        [inputFormControl]="getAutocompleteCountryInput()" [readonly]="readonlyCustomerForm" valueType="number"
        [apiService]="countriesService" [apiMethod]="'list'" [minChars]="1" [useApiSearch]="true"
        [nameApiSearch]="'name'" [optionsKey]="'countries'" [valueOption]="'name'" [keyOption]="'countryId'" />
    </div>
    <div class="col-sm-6 col-md-3 mt-2">
      <input-field type="text" [inputFormControl]="getAddressInput()" label="Address" placeholder="Insert address"
        [initialValue]="customer?.country" [readonly]="readonlyCustomerForm" />
    </div>
    <div class="col-sm-6 col-md-3 mt-2">
      <input-field type="text" [inputFormControl]="getZipCodeInput()" label="Zip Code"
        placeholder="Insert zip code" [readonly]="readonlyCustomerForm" />
    </div>
    <div class="col-sm-6 col-md-3 mt-2">
      <input-field type="text" [inputFormControl]="getCityInput()" label="City" placeholder="City"
        [readonly]="readonlyCustomerForm" />
    </div>
    <div class="col-sm-6 col-md-4 mt-2">
      <select-field label="Registration type" [selectFormControl]="getRegistrationTypeInput()"
        [readonly]="readonlyCustomerForm" [options]="optionsRegistrationType" (valueChange)="onRegistrationTypeChange($event)" />
    </div>
    <div class="col-sm-6 col-md-4 mt-2">
      <input-field type="text" [inputFormControl]="getRegistrationTypeValueInput()"
        [label]="selectedRegistrationType || 'Registration Value'"
        [placeholder]="selectedRegistrationType || 'Registration Value'"
        [readonly]="readonlyCustomerForm" />
    </div>
    <div class="col-sm-6 col-md-4 mt-2">
      <language-client [radioFormControl]="getClientLanguageInput()" label="Client Language"
        (languageChange)="getClientLanguageInput().setValue($event)" [disabled]="readonlyCustomerForm" />
    </div>
  </div>
  <hr class="mt-4 mb-4">
  <div class="row">
    <switch-field [isChecked]="getIsClientInput().value" message="Consider this company as a client"
      (isCheckedChange)="getIsClientInput().setValue($event)" [readonly]="readonlyCustomerForm" />
  </div>
  <hr class="mt-4 mb-1">
  <div class="row">
    <div class="col-sm-4 mt-2">
      <input-field type="text" [inputFormControl]="getDirectorNameInput()" label="Director Name"
        placeholder="Director Name" [readonly]="readonlyCustomerForm" />
    </div>
    <div class="col-sm-4 mt-2">
      <input-field type="text" [inputFormControl]="getDirectorDocumentInput()" label="Director Document"
        placeholder="Director Document" [readonly]="readonlyCustomerForm" />
    </div>
    <div class="col-sm-4 mt-2 introducer-autocomplete">
      <autocomplete-field [label]="'Introducer'" [placeholder]="'Search...'" [options]="optionsIntroducer"
        [inputFormControl]="getAutocompleteIntroducernput()" [readonly]="readonlyCustomerForm"
        [displayKeyValue]="true" (valueChange)="onSearchValueChange($event)" [apiService]="optionsService"
        [nameApiSearch]="'name'" [apiMethod]="'introducers'" [minChars]="1" [useApiSearch]="true"
        [optionsKey]="'introducers'" [valueOption]="'name'" [keyOption]="'introducerId'"
        [valueType]="'number'" />
    </div>

  </div>
  @if (!readonlyCustomerForm) {
    <div class="text-center mt-4">
      <button type="button" class="btn btn-success px-4 py-2" (click)="saveRequested.emit()">
        Save
      </button>
    </div>
  }
</form>